import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Chatroom } from '../components/Chatroom';
import { getTokenFromLocalStorage } from '../lib/local-storage';
import useChatrooms from '../store/chatrooms';
import useUser from '../store/user';

const SingleChatroomPage = () => {
	const [loading, setLoading] = useState(true);
	const [token, setToken] = useState<string | null>(null);
	const routerParams = useParams();
	const { user } = useUser();

	const chatroomKey = routerParams.chatroomKey;

	const { chatrooms } = useChatrooms();

	const orderKey = Object.values(chatrooms).find((c) => c.chatroomKey === chatroomKey)?.orderKey;

	useEffect(() => {
		const token = getTokenFromLocalStorage();
		setToken(token);
		setLoading(false);
	}, []);

	return loading || !token ? (
		<p className="p-2">One moment...</p>
	) : (
		<Chatroom token={token} user={user} chatroomKey={chatroomKey} orderKey={orderKey} />
	);
};

export default SingleChatroomPage;
